/* ============================================================
   LIV-OUTDOORS CUSTOM NAV — JavaScript
   Asset: liv-outdoors-nav.js
   Load in layout/theme.liquid before </body>:
   {{ 'liv-outdoors-nav.js' | asset_url | script_tag }}
   ============================================================ */

(function () {
  'use strict';

  var nav        = document.getElementById('lo-nav');
  var utilBar    = document.getElementById('lo-util-bar');
  var hamburger  = document.getElementById('lo-hamburger');
  var mobileNav  = document.getElementById('lo-mobile-nav');
  var searchBtn  = document.getElementById('lo-search-btn');
  var searchModal  = document.getElementById('lo-search-modal');
  var searchOverlay = document.getElementById('lo-search-overlay');
  var searchClose  = document.getElementById('lo-search-close');
  var searchInput  = document.getElementById('lo-search-input');
  var cartBtn    = document.getElementById('lo-cart-btn');
  var cartDrawer = document.getElementById('lo-cart-drawer');
  var cartOverlay = document.getElementById('lo-cart-overlay');
  var cartClose  = document.getElementById('lo-cart-close');
  var cartContinue = document.getElementById('lo-cart-continue');
  var frost      = document.getElementById('lo-frost');

  var activeMega = null;
  var activeDropdown = null;
  var closeTimer = null;

  // ── Frost helpers ──────────────────────────────────────────
  function showFrost() { if (frost) frost.classList.add('open'); }
  function hideFrost() { if (frost) frost.classList.remove('open'); }

  // ── Scroll: collapse util bar + frosted nav ────────────────
  window.addEventListener('scroll', function () {
    if (window.scrollY > 60) {
      if (nav) nav.classList.add('scrolled');
      if (utilBar) utilBar.classList.add('hide');
    } else {
      if (nav) nav.classList.remove('scrolled');
      if (utilBar) utilBar.classList.remove('hide');
    }
  });

  // ── Search ─────────────────────────────────────────────────
  function openSearch() {
    if (searchModal) searchModal.classList.add('open');
    if (searchOverlay) searchOverlay.classList.add('open');
    closeAllMenus();
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 50);
  }
  function closeSearch() {
    if (searchModal) searchModal.classList.remove('open');
    if (searchOverlay) searchOverlay.classList.remove('open');
    if (searchInput) searchInput.value = '';
  }
  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);

  // ── Cart drawer ────────────────────────────────────────────
  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (cartBtn) cartBtn.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartContinue) cartContinue.addEventListener('click', closeCart);

  // ── Escape key ─────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSearch(); closeCart(); closeAllMenus(); }
  });

  // ── Close all open menus ────────────────────────────────────
  function closeAllMenus() {
    if (activeMega) { activeMega.classList.remove('open'); activeMega = null; }
    if (activeDropdown) { activeDropdown.classList.remove('open'); activeDropdown = null; }
    hideFrost();
  }

  // ── MEGA MENU (Decks, Outdoor Kitchens) ────────────────────
  document.querySelectorAll('[data-lo-mega]').forEach(function (btn) {
    var id = btn.getAttribute('data-lo-mega');
    var panel = document.getElementById(id);
    var parent = btn.closest('.lo-nav-item');
    if (!panel || !parent) return;

    function open() {
      clearTimeout(closeTimer);
      closeSearch();
      if (activeDropdown) { activeDropdown.classList.remove('open'); activeDropdown = null; }
      if (activeMega && activeMega !== panel) activeMega.classList.remove('open');
      panel.classList.add('open');
      activeMega = panel;
      showFrost();
    }
    function scheduleClose() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('open');
        if (activeMega === panel) { activeMega = null; hideFrost(); }
      }, 130);
    }

    parent.addEventListener('mouseenter', open);
    parent.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);
  });

  // ── NORMAL DROPDOWN (Pergolas, About) ──────────────────────
  document.querySelectorAll('[data-lo-dropdown]').forEach(function (btn) {
    var id = btn.getAttribute('data-lo-dropdown');
    var panel = document.getElementById(id);
    var parent = btn.closest('.lo-nav-item');
    if (!panel || !parent) return;

    function open() {
      clearTimeout(closeTimer);
      closeSearch();
      if (activeMega) { activeMega.classList.remove('open'); activeMega = null; }
      if (activeDropdown && activeDropdown !== panel) activeDropdown.classList.remove('open');
      panel.classList.add('open');
      activeDropdown = panel;
      showFrost();
    }
    function scheduleClose() {
      closeTimer = setTimeout(function () {
        panel.classList.remove('open');
        if (activeDropdown === panel) { activeDropdown = null; hideFrost(); }
      }, 130);
    }

    parent.addEventListener('mouseenter', open);
    parent.addEventListener('mouseleave', scheduleClose);
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', scheduleClose);
  });

  // ── Click outside closes all ────────────────────────────────
  document.addEventListener('click', function (e) {
    if (nav && !nav.contains(e.target)) closeAllMenus();
  });

  if (frost) frost.addEventListener('click', closeAllMenus);

  // ── Hamburger ───────────────────────────────────────────────
  if (hamburger) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('open');
      if (mobileNav) mobileNav.classList.toggle('open');
    });
  }

  // ── Cart count from Shopify AJAX API ───────────────────────
  // Updates the cart badge count dynamically
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var badges = document.querySelectorAll('.lo-cart-badge, .lo-cart-count');
        badges.forEach(function (el) {
          el.textContent = data.item_count;
          el.style.display = data.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  // Run on load
  updateCartCount();

  // Re-run after any add-to-cart events (listens for Shopify cart:add)
  document.addEventListener('cart:refresh', updateCartCount);

})();